// @flow

/**
 * getResizedImage
 * @return {string|string} resized image string
 */
const getResizedImage = (image, viewport, imageType) => {
  const imagePath = image && image.href;
  if (!imagePath) return image;
  const imageSize =
    (imageType && imageSizes[imageType] && imageSizes[imageType][viewport]) ||
    imageSizes['default'];
  return { ...image, href: imagePath.replace(/{resize}/i, imageSize) };
};

const imageSizes = {
  verticalCardImage: {
    xs: 'w535h400',
    sm: 'w330h248',
    md: 'w315h236',
    lg: 'w240h180'
  },
  horizontalCardImage: {
    xs: 'w700h525',
    sm: 'w700h525',
    md: 'w385h289',
    lg: 'w385h289'
  },
  GalleryMainImage: {
    xs: 'w700h525',
    sm: 'w700h525',
    md: 'w660h440',
    lg: 'w660h440'
  },
  GalleryThumb: {
    md: 'w135h90',
    lg: 'w135h90'
  },
  default: 'w315h210'
};

export default getResizedImage;



// WEBPACK FOOTER //
// ./src/utils/getResizedImage/index.js